import { Navigate } from "react-router-dom";
import useAuth from "app/hooks/useAuth";

const AuthGuard = ({ children }) => {
  const { isAuthenticated, user } = useAuth();

  if (!isAuthenticated) {
    console.warn("User not authenticated. Redirecting to login.");
    return <Navigate to="/session/signin" />;
  }

  console.log("User authenticated:", user);
  return children;
};

export default AuthGuard;
